"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    empty: {
        en: "Empty",
        es: "Vacío",
    },
    maskAsRead: {
        en: "Read all ",
        es: "Marcar leídas las ",
    },
    alertDisabled: {
        en: 'Alert Disabled',
        es: 'Alerta Desactivada',
    },
    alertDisabledByAdmin: {
        en: 'This alert was disabled, contact your admin',
        es: 'Esta alerta fue desactivada, contactar administrador',
    },
    alertWhen: {
        en: "Alert when",
        es: "Alertar cuando ",
    },
    alertTitle: {
        en: "Alerts",
        es: "Alertas",
    },
    all: {
        en: "Configure selected units",
        es: "Configurar unidades seleccionadas",
    },
    checkAll: {
        en: "Check all",
        es: "Seleccionar todos",
    },
    checkAllCount: {
        en: "Check all ({count})",
        es: "Seleccionar todos ({count})",
    },
    desktop: {
        en: "Desktop alert",
        es: "Alerta de escritorio.",
    },
    temporary: {
        en: "Temporary",
        es: "Temporal",
    },
    persistent: {
        en: "Persistent",
        es: "Persistir",
    },
    mobile: {
        en: "Mobile alert",
        es: "Alerta de celular.",
    },
    emailAlert: {
        en: "Email alert",
        es: "Alerta de correo",
    },
    smsAlert: {
        en: "SMS alert",
        es: "Alerta de SMS",
    },
    persistentMessage: {
        en: "This is a persistent notification",
        es: "Esta es una notificación persistente.",
    },
    temporaryMessage: {
        en: "This is a temporary notification",
        es: "Esta es una notificación temporal",
    },
    dismiss: {
        en: "Dismiss",
        es: "Cerrar",
    },
    seconds: {
        en: "seconds",
        es: "seconds",
    },
    EmailActivated: {
        en: "Your account has been activated! you will be redirected in ",
        es: "Tu correo electrónico a sido verificado! Serás redireccionado en ",
    },
    SmsActivated: {
        en: "Your number has been verified! you will be redirected in ",
        es: "Tu numero celular a sido verificado! Serás redireccionado en ",
    },
    traceNotFound: {
        en: "There is no information on that date, {date} was loaded instead.",
        es: "No hay información ese día, se cargo el {date} en su lugar.",
    },
    smsVerification: {
        en: "SMS verification",
        es: "Verificación de SMS",
    },
    emailVerification: {
        en: "Email verification",
        es: "Verificación de correo electrónico",
    },
    validRange: {
        en: "Please enter a valid range of hours",
        es: "Por favor ingresar rango de horas validos",
    },
    sameRange: {
        en: "Both hours are the same please enter a valid range of hours",
        es: "Ambas horas son iguales, por favor ingresar rango de horas validos",
    },
    inOrOutRange: {
        en: "The selected range is in or out of another range, please entre a valid range.",
        es: "El rango seleccionado esta dentro o fuera de otro rango, por favor ingrese rango valido.",
    },
    autorizeSchedule: {
        en: "Authorize Schedule",
        es: "Horario Autorizado",
    },
    unAuthorizeSchedule: {
        en: "Activity outside authorized hours",
        es: "Actividad fuera de horario autorizado",
    },
    fotoInProcessTitle: {
        en: "Processing new Photo.",
        es: "Procesando Nueva Fotografía.",
    },
    fotoProcessedTitle: {
        en: "Photo processed.",
        es: "Fotografía Procesada.",
    },
    fotoInProcess: {
        en: "An image is been processing for unit {description}.",
        es: "Se esta procesando una foto de la unidad {description}.",
    },
    fotoProcessed: {
        en: "An image finished processing for unit {description}.",
        es: "Se termino de procesar una foto de la unidad {description}.",
    },
    reportReadyToDownload: {
        en: "The report {name} has been processed, check your email or click on the download button.",
        es: "Se termino de procesar el reporte  de {name}, revisa tu correo o has click en el botón de descarga.",
    },
    displacementAlert: {
        en: "Displacement Alert {description}",
        es: "Alerta de desplazamiento {description}",
    },
    busyDriver: {
        en: "{driver} it's assigned to another device, assign to this device anyway?",
        es: "{driver} está asignado a otro vehículo, ¿Asignar a este vehículo de todas formas?",
    },
    deleteDriver: {
        en: "Do you want to remove {driver}?",
        es: "Quieres eliminar a {driver}?",
    },
    mobileNotifications: {
        en: "Mobile app notifications",
        es: "Notificaciones en la app móvil",
    },
    emailNotifications: {
        en: "Email notifications",
        es: "Notificaciones vía email",
    },
    emailNotificationsMessage: {
        en: "The entered email addresses will receive a mail to activate the notifications.",
        es: "Se enviará un correo a las direcciones ingresadas para activar las notificaciones.",
    },
    smsNotifications: {
        en: "SMS notifications",
        es: "Notificaciones vía SMS",
    },
    smsNotificationsMessage: {
        en: "An activation link will be send to the entered numbers.",
        es: "Se enviará un link de activación a los números ingresados.",
    },
    selectMinutes: {
        en: 'Select minutes',
        es: 'Seleccionar minutos'
    },
};
exports.default = translations;
